module.exports = __webpack_public_path__ + "assets/player-lancapse.edee7fbc.svg";